// components/NextLink.tsx
import React from 'react';
import {Link, LinkProps as MuiLinkProps} from '@mui/material';
import NextLink, {LinkProps as NextLinkProps} from 'next/link';
import {forwardRef} from 'react';

type NextMuiLinkProps = Omit<MuiLinkProps, 'href'> &
  Omit<NextLinkProps, 'href'> & {
    href: string;
  };

const MuiLink = forwardRef<HTMLAnchorElement, NextMuiLinkProps>(
  function MuiLink(props, ref) {
    const {href, as, replace, scroll, shallow, prefetch, locale, ...muiProps} =
      props;

    return (
      <Link
        component={NextLink}
        ref={ref}
        href={href}
        as={as}
        replace={replace}
        scroll={scroll}
        shallow={shallow}
        prefetch={prefetch}
        locale={locale}
        {...muiProps}
      />
    );
  }
);

export default MuiLink;
